import { render } from "./UpgraderFilterSearch.vue?vue&type=template&id=566967a7&scoped=true"
import script from "./UpgraderFilterSearch.vue?vue&type=script&lang=js"
export * from "./UpgraderFilterSearch.vue?vue&type=script&lang=js"

import "./UpgraderFilterSearch.vue?vue&type=style&index=0&id=566967a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566967a7"]])

export default __exports__